/**
 * Recipe Benefits Section - Mobile Carousel
 * Implements Swiper.js carousel for mobile card display
 */

document.addEventListener('DOMContentLoaded', function() {
  let swiperInstance = null;

  // Only initialize Swiper on mobile devices
  function initMobileCarousel() {
    const swiperContainer = document.querySelector('.recipe-benefits__swiper');

    if (!swiperContainer) return;

    // Check if we're on mobile (≤768px)
    const isMobile = window.innerWidth <= 768;

    if (isMobile && typeof Swiper !== 'undefined') {
      // Only initialize if not already initialized
      if (!swiperInstance) {
        swiperInstance = new Swiper('.recipe-benefits__swiper', {
          slidesPerView: 1.4,
          spaceBetween: 36,
          centeredSlides: true,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          pagination: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            480: {
              slidesPerView: 1.4,
              spaceBetween: 32,
            },
            640: {
              slidesPerView: 1.5,
              spaceBetween: 32,
            }
          },
          on: {
            init: function() {
              console.log('Recipe Benefits Swiper initialized');
            },
            destroy: function() {
              console.log('Recipe Benefits Swiper destroyed');
            }
          }
        });
      }
    } else {
      // Destroy swiper if it exists and we're not on mobile
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }
  }

  // Initialize on load
  initMobileCarousel();

  // Reinitialize on resize (debounced)
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      initMobileCarousel();
    }, 250);
  });
});
